import SectionReveal from "@/components/SectionReveal";
export default function ProductEvidence({
  src,
  alt,
  caption,
  meta,
  dark = true,
  eager = false,
  className = "",
}) {
  return (
    <SectionReveal as="figure" className={`lf-product-evidence ${dark ? "lf-product-evidence-dark" : ""} ${className}`}>
      <div className="lf-product-evidence-bar" aria-hidden="true">
        <span /><span /><span />
        <i>{meta || "LightningFlow operational interface"}</i>
      </div>
      <img
        src={src}
        srcSet={src.includes("lightningflow-command-center-v9.webp") ? "/platform/lightningflow-command-center-v9-960.webp 960w, /platform/lightningflow-command-center-v9.webp 1600w" : undefined}
        sizes={src.includes("lightningflow-command-center-v9.webp") ? "(max-width: 767px) 100vw, 90vw" : undefined}
        alt={alt}
        width="1600"
        height="757"
        loading={eager ? "eager" : "lazy"}
        decoding="async"
      />
      <figcaption>{caption}</figcaption>
    </SectionReveal>
  );
}
